module.exports = __webpack_public_path__ + "system/img/401.089007e7.gif";